import { render } from "./OrderAddressEditWidget.vue?vue&type=template&id=7201ae10&ts=true"
import script from "./OrderAddressEditWidget.ts?vue&type=script&lang=ts&external"
export * from "./OrderAddressEditWidget.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__